var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb40" }, [
    _c(
      "div",
      { staticClass: "mb20" },
      [
        _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.item.name))]),
        _vm.item.current && _vm.showTag
          ? _c(
              "yxtf-tag",
              { staticClass: "ml8", attrs: { size: "mini", type: "warning" } },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("pc_gwnl_web_competencyStandards")) +
                    "\n    "
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm.item.description
      ? _c("div", { staticClass: "mb16" }, [
          _c("div", { staticClass: "label mb8" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_gwnl_global_lbl_levelDescription")) +
                "\n    "
            ),
          ]),
          _c("div", {
            staticClass: "info",
            domProps: { textContent: _vm._s(_vm.item.description) },
          }),
        ])
      : _vm._e(),
    _vm.item.behavior
      ? _c("div", [
          _c("div", { staticClass: "label mb8" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_gwnl_global_lbl_behavior")) +
                "\n    "
            ),
          ]),
          _c("div", {
            staticClass: "info",
            domProps: { textContent: _vm._s(_vm.item.behavior) },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }